import React, { useRef, useEffect, FC, Fragment } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import { API_URL } from "api/config";
import DatePickerCustomDay from "./DatePickerCustomDay";
import DatePickerCustomHeaderTwoMonth from "./DatePickerCustomHeaderTwoMonth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
interface Booking {
  checkinDate: string;
  checkoutDate: string;
}
interface SectionDateRangeProps {
  price: any;
  startDate: any;
  setStartDate: any;
  endDate: any;
  setEndDate: any;
  setIsPopoverOpen: any;
  bookings: any;
  getDayClassName: any;
  bookedDates:any;
}
const SectionDateRange: FC<SectionDateRangeProps> = ({
  price,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setIsPopoverOpen,
  getDayClassName,
  bookedDates,
}) => {
  const calendarRef = useRef<HTMLDivElement>(null);

  const isBlockedRange = (start: Date, end: Date) => {
    return bookedDates.some((d: Date) => d > start && d < end);
  };

  const onChangeDate = (dates: [Date | null, Date | null] | null) => {
    if (dates) {
      const [start, end] = dates;

      if (start && end) {
        if (isBlockedRange(start, end)) {
          toast.warning("Invalid selection! A booking exists in this range.");
          return; 
        }
        setStartDate(start);
        setEndDate(end);
        setIsPopoverOpen(true);
      } else {
        setStartDate(start);
        setEndDate(end);
      }
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };
    // Reset dates when clicking outside the calendar
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target as Node)) {
          setStartDate(null);
          setEndDate(null);
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [setStartDate, setEndDate]);

  const renderSectionCheckIndate = () => {
    return (
      <div ref={calendarRef} className="listingSection__wrap overflow-hidden">
        <div>
          <div className="flex justify-between">
            <span className="text-3xl font-semibold self-center">
              <div
                className={`
                
                  "2xl:p-4 lg:p-1 p-1 flex justify-between items-center space-x-2 rounded-lg"
              `}
              >
                <h3
                  className="text-2xl lg:font-semibold font-[500] leading-6 text-gray-900"
                  id="headlessui-dialog-title-70"
                >
                  Availability
                </h3>
              </div>
            </span>
          </div>
        </div>
        {/* CONTENT */}

        <div className="react-datepicker--two-columns">
          <DatePicker
            onChange={onChangeDate}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            monthsShown={1}
            showPopperArrow={false}
            inline
            minDate={new Date()}
            highlightDates={bookedDates}
            // filterDate={isDateSelectable}
            dayClassName={getDayClassName}
            renderCustomHeader={(p) => (
              <DatePickerCustomHeaderTwoMonth {...p} />
            )}
            renderDayContents={(day: number, date: Date) => (
              <DatePickerCustomDay dayOfMonth={day} date={date} />
            )}
          />
     
        </div>
      </div>
    );
  };

  return renderSectionCheckIndate();
};

export default SectionDateRange;
